import { ContentTextData } from './ContainContentText';
import { FC, useEffect } from 'react';
import { H3, ParagraphLRegular } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { ScrollView, View } from 'react-native';
import { SessionPresentationProps } from '../config';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { useBreakpointStyles } from '../../../hooks/useBreakpointStyles';

export interface PresentContentTextProps extends SessionPresentationProps<ContentTextData> {
  data: ContentTextData,
}

const _PresentContentText: FC<PresentContentTextProps> = ({
  data,
}) => {
  const content = data?.content;
  const inPath = data?.inPath;

  const styles = useBreakpointStyles({
    container: {
      width: '100%',
      flex: 1,
    },
    scrollContainer: {
      flexGrow: 1,
      paddingHorizontal: SPACING['sp-16'],
      lg: { paddingHorizontal: SPACING['sp-40'] },
    },
    titleContainer: {
      marginBottom: SPACING['sp-20'],
      lg: { marginTop: SPACING['sp-32'] },
    },
    contentContainer: {
      marginBottom: SPACING['sp-20'],
      lg: {
        marginTop: SPACING['sp-64'],
        marginBottom: SPACING['sp-48'],
        padding: SPACING['sp-16'],
      },
    },
  });

  useEffect(() => {
    logAmplitude('Activity Started', {
      contentType: 'text',
      activityId: content?.humanReadableId,
      activityType: content?.activityType,
      from: inPath ? 'path' : 'library',
    });
    return () => {
      logAmplitude('Activity Finished', {
        contentType: 'text',
        activityId: content?.humanReadableId,
      });
    };
  }, []);

  return (
    <View style={styles.container}>
      <ScrollView
        persistentScrollbar={true}
        contentContainerStyle={styles.scrollContainer}
        onStartShouldSetResponder={() => true}
      >
        <View style={styles.titleContainer}>
          <H3>
            {content?.title}
          </H3>
        </View>
        <View style={styles.contentContainer}>
          <ParagraphLRegular>
            {content?.longDescription}
          </ParagraphLRegular>
        </View>
      </ScrollView>
    </View>
  );
};

export const PresentContentText = observer(_PresentContentText);
